import { css } from "@emotion/react";
import { bpoints } from "../../../Utils";

export const shareCSS = () => css`
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    justify-content: space-between;

    section {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 2rem;

        .share-container {
            background: white;
            border-radius: 1rem;
            padding: 2rem;
            text-align: center;
            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
            max-width: 600px;
            width: 100%;

            .logo {
                width: 150px;
                margin-bottom: 1rem;
            }

            h2 {
                color: #21588C;
                margin-bottom: 2rem;
                font-size: calc(1.1rem + 0.5vw);
            }

            .ButtonRow {
                display: flex;
                gap: 20px;
                color: white;
                font-weight: 500;
                font-size: calc(1.1rem + 0.5vw);
                letter-spacing: 0.74px;
                width: 90%;
                margin: 0 auto;
                flex-direction: column;

                .Button {
                    cursor: pointer;
                    border-radius: 25px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    padding: 1rem 0;
                    flex-basis: 0;
                    flex-grow: 1;
                    transition: 300ms;
                }

                .Green {
                    background-color: #22EC9A;
                    :hover {
                        background-color: #2ad690;
                    }
                }

                .Blue {
                    background-color: #32B8DF !important;
                    :hover {
                        background-color: #2da5c8;
                    }
                }
            }
        }
    }

    @media (max-width: ${bpoints.mobile.w}px) {
        section {
            padding: 1rem;
        }

        .ButtonRow {
            flex-direction: column;
            gap: 15px;
            font-size: calc(1.3rem + 1.5vw);
            width: 100%;

            .Button {
                padding: 1rem 0;
            }
        }
    }

    .Modal {
        h2 {
            background: linear-gradient(90deg, #34c6f1 6.22%, #1fdd8f 77.34%);
            -webkit-background-clip: text;
            background-clip: text;
            -webkit-text-fill-color: transparent;
            text-align: center;
            margin-bottom: 1.5rem;
        }

        .content {
            font-style: normal;
            font-weight: 500;
            line-height: 166.667%;
            font-size: calc(0.6rem + 0.9vw);
        }

        .header-with-image {
            background: linear-gradient(90deg, #34c6f1 6.22%, #1fdd8f 77.34%);
            -webkit-background-clip: text;
            background-clip: text;
            -webkit-text-fill-color: transparent;
        }

        .Button {
            display: inline-block;
            outline: none;
            cursor: pointer;
            font-size: 14px;
            line-height: 20px;
            font-weight: 600;
            border-radius: 8px;
            padding: 10px 18px;
            border: 1px solid #222222;
            transition: box-shadow 0.2s ease, transform 0.1s ease;
            background: #fff;
            color: white;

            &:hover {
                border-color: #000000;
                background: #f7f7f7;
            }
        }

        .Blue {
            background: #34C6F1;
            border: unset;
            &:hover {
                background: #2da5c8;
                border: unset;
            }
        }
    }

    // Mantener los estilos del z-index
    :global(.p-dialog-mask) {
        z-index: 999 !important;
    }

    :global(.p-dialog) {
        z-index: 1000 !important;
    }

    :global(.p-dialog-mask.p-component-overlay) {
        z-index: 999 !important;
    }
`;
